import application from 'application/application';

const controller = 'DefaultAddProcessesOabController';

application.controller(controller, [
	'$state',
	'$rootScope',
	'$scope',
	'$timeout',
	'$http',
	'$stateParams',
	'$location',
	'API',
	'helper',

	(
		$state,
		$rootScope,
		$scope,
		$timeout,
		$http,
		$stateParams,
		$location,
		API,
		helper
	) => {
		$scope.title = '';
		$scope.quantityPerPage = 20;
		$scope.validItems = 0;

		$scope.filter = {
			process: '',
			idProcess: null,
			situation: '',
			idSituation: '',
			court: '',
			idCourt: ''
		};

		$scope.selectAllProcessesChecked = false;
		$scope.newProcessChecked = [];

		$scope.processesList = [];

		$scope.paramProcessId = $stateParams.id;

		$scope.situations = [];
		$scope.courts = [];

		$scope.paginacao = {
			registrosTotal: 0,
			registrosPorPagina: 20,
			paginaTotal: 1,
			paginaAtual: 1
		};

		$scope.clearAll = false;
		$scope.allProcessesSelected = false;

		$scope.isLoadingProcesses = true;

		$scope.processSelected = [];
		$scope.paramsBuscaProcesso = {
			numeroProcesso: '',
			idPesqProcOABXParamUsCliente: $scope.paramProcessId,
			registrosPorPagina: 100
		};
		$scope.courtsSelected = [];
		$scope.paramsBuscaTribunal = {
			sigla: '',
			ativo: true,
			campos: 'id,nome,sigla'
		};

		$scope.invalidIdTitle = '';
		$scope.invalidIdMessage = '';

		$scope.onInit = () => {
			const userParamsSession = sessionStorage.getItem('parametros-usuarios');

			let dataParameterUsers = null;

			if (
				userParamsSession &&
				userParamsSession != undefined &&
				userParamsSession != 'undefined'
			) {
				dataParameterUsers = JSON.parse(userParamsSession);
			}

			$scope.fetchJudicialBranches();
			$scope.fetchSituations();

			let record = dataParameterUsers || null;

			if (record) {
				$scope.parameterUsers = record;

				$scope.idQtdItensPagina = $scope.parameterUsers.idParamUsuarioProdAdv;
				$scope.quantityPerPage =
					$scope.parameterUsers.qtdRegistroMovPorPagina || 20;

				$scope.paginacao.registrosPorPagina = $scope.quantityPerPage;
			}

			$scope.updateMasterState();

			let buscas = $location.search().buscas;

			$scope.paginaCentralDeBuscas = buscas != 0;

			$scope.filter = {
				process: '',
				situation: '',
				idSituation: '',
				court: '',
				idCourt: ''
			};

			$scope.lastFilter = { ...$scope.filter };

			let paginaUrl = parseInt($location.search().pagina, 10);
			let processoUrl = $location.search().processo;
			let situacaoUrl = $location.search().situacao;
			let tribunalUrl = $location.search().tribunal;

			if (!isNaN(paginaUrl)) {
				$scope.paginacao.paginaAtual = paginaUrl;
			}

			if (!isNaN(processoUrl)) {
				$scope.filter.process = processoUrl;
			}
			if (!isNaN(situacaoUrl)) {
				$scope.filter.idSituation = situacaoUrl;
			}
			if (!isNaN(tribunalUrl)) {
				$scope.filter.idCourt = tribunalUrl;
			}

			$scope.fetchHeader();
			$scope.fetchProcesses();
		};

		$scope.fetchJudicialBranches = () => {
			const params = {
				ativo: true,
				registrosPorPagina: 100,
				...helper.httpFields(['id', 'nome', 'sigla'])
			};

			$http({
				...helper.http(API.judicialBranches, 'GET'),
				params: params
			}).then(response => {
				if (response && response.data && response.data.itens) {
					$scope.courts = response.data.itens;
				}
			});
		};

		$scope.fetchSituations = () => {
			const params = {
				...helper.httpFields(['*'])
			};

			$http({
				...helper.http(API.quickRegister, 'getSituacaoPesquisa'),
				method: 'GET',
				params: params,
				messageOverride: {
					error() {}
				}
			})
				.then(response => {
					if (response && response.data && response.data.itens) {
						$scope.situations = response.data.itens;

						for (let situation of $scope.situations) {
							if (Number(situation.id) > 0) {
								situation.id = '-' + situation.id;
							}
						}
					}
				})
				.finally(() => {
					$scope.situations.push({
						id: 'monitorado',
						nome: 'Monitorado'
					});
				});
		};

		$scope.fetchHeader = () => {
			$http({
				...helper.http(API.quickRegister, 'getInfoSearch'),
				method: 'GET',
				params: {
					idPesqProcOABXParamUsCliente: $scope.paramProcessId
				},
				messageOverride: {
					error() {}
				}
			}).then(({ data }) => {
				if (
					data &&
					data.status &&
					data.status.codigo == 200 &&
					data.itens &&
					data.itens.length > 0
				) {
					const foundInfo = data.itens[0];

					$scope.title = foundInfo.numeroOAB + '/' + foundInfo.uf;
				}
			});
		};

		$scope.fetchProcesses = (page = null) => {
			let params = {
				idPesqProcOABXParamUsCliente: $scope.paramProcessId
			};

			if ($scope.filter.process) {
				params.numeroProcesso = $scope.filter.process;
			}

			if ($scope.filter.idSituation) {
				if ($scope.filter.idSituation == 'monitorado') {
					params.monitorado = true;
				} else {
					params.idSitProcPesqOABUsCliente = $scope.filter.idSituation;
				}
			}

			if ($scope.filter.idCourt) {
				params.idOrgaoJudiciario = $scope.filter.idCourt;
			}

			if (page && page != null) {
				params.paginaAtual = page;
			}

			if ($scope.quantityPerPage) {
				params.registrosPorPagina = $scope.quantityPerPage;
			}

			$scope.isLoadingProcesses = true;

			$http({
				...helper.http(API.quickRegister, 'getInfoAbstract'),
				method: 'GET',
				params,
				messageOverride: {
					error() {}
				}
			})
				.then(({ data }) => {
					if (data.status && data.status.codigo == 200) {
						$scope.invalidIdTitle = '';
						$scope.invalidIdMessage = '';

						$scope.processesList = data.itens;

						//Se for necessário aplicar no front a regra de remover números
						//de processos duplicados, comenta o código acima, e descomenta
						//o código abaixo.

						// const uniqueProcesses = {};
						// data.itens.forEach(item => {
						// 	const numero = item.numeroProcesso;
						// 	if (!uniqueProcesses[numero]) {
						// 		uniqueProcesses[numero] = item;
						// 		return;
						// 	}
						// 	const dataAtual = new Date(item.dataDistribuicao);
						// 	const dataSalva = new Date(
						// 		uniqueProcesses[numero].dataDistribuicao
						// 	);
						// 	if (dataAtual > dataSalva) {
						// 		uniqueProcesses[numero] = item;
						// 	}
						// });
						// $scope.processesList = Object.values(uniqueProcesses);

						$scope.validItems = 0;

						if (data.itens && data.itens.length > 0) {
							for (let item of data.itens) {
								if (
									item.idSitProcPesqOABUsCliente == '-1' ||
									item.idSitProcPesqOABUsCliente == '-4'
								) {
									$scope.validItems++;
								}
							}
						}

						for (let process of $scope.newProcessChecked) {
							if (
								process &&
								(process.idProcPesqOABUsCliente || process.numeroProcesso)
							) {
								for (let item of $scope.processesList) {
									if (
										item &&
										(item.idProcPesqOABUsCliente || item.numeroProcesso)
									) {
										if (
											item.idProcPesqOABUsCliente ==
												process.idProcPesqOABUsCliente ||
											item.numeroProcesso == process.numeroProcesso
										) {
											item.__checked__ = true;
										}
									}
								}
							}
						}

						for (let item of $scope.processesList) {
							if (item.idSitProcPesqOABUsCliente == -1 && item.monitorado) {
								item.sitProcPesqOABUsCliente = 'Monitorado';
								item.nomeClassifSitProcPesqOABUsCl = 'Monitorado';
							}

							if (
								(item.idSitProcPesqOABUsCliente == -1 ||
									item.idSitProcPesqOABUsCliente == -4) &&
								$scope.allProcessesSelected
							) {
								item.__checked__ = true;
							}
						}

						$scope.paginacao = data.paginacao;
					}
				})
				.catch(error => {
					$scope.invalidIdTitle = 'Erro ao consultar.';
					$scope.invalidIdMessage = 'Pesquisa não encontrada.';

					if (error && error.data && error.data.status) {
						$scope.invalidIdTitle =
							error.data.status.mensagem || 'Erro ao consultar.';

						if (error.data.status.erros && error.data.status.erros.length > 0) {
							$scope.invalidIdMessage = error.data.status.erros[0].mensagem;
						}
					}
				})
				.finally(() => {
					$scope.isLoadingProcesses = false;
				});
		};

		$scope.syncSelection = () => {
			const items = $scope.processesList || [];

			$scope.newProcessChecked = items.filter(it => !!it.__checked__);

			const total = $scope.validItems;
			const checked = $scope.newProcessChecked.length;

			$timeout(() => {
				const el = document.getElementById('movement-checkbox-all');

				if (el) {
					el.indeterminate = checked > 0 && checked < total;
					el.checked = total > 0 && checked === total;
				}
				$scope.selectAllProcessesChecked = total > 0 && checked === total;
			});
		};

		$scope.updateMasterState = () => {
			const items = $scope.processesList || [];

			const total = $scope.validItems;
			const checkedCount = items.filter(it => !!it.__checked__).length;

			$scope.selectAllProcessesChecked = total > 0 && checkedCount == total;

			const el = document.getElementById('movement-checkbox-all');

			if (el) {
				el.indeterminate = checkedCount > 0 && checkedCount < total;
				el.checked = total > 0 && checkedCount === total;
			}
			$scope.$applyAsync();
		};

		$scope.selectAllProcesses = item => {
			$scope.clearAll = false;
			$scope.newProcessChecked = $scope.newProcessChecked
				? $scope.newProcessChecked
				: [];

			setTimeout(() => {
				item.map(value => {
					if (value.__checked__ === true) {
						if (!!$scope.newProcessChecked) {
							$scope.newProcessChecked = $scope.newProcessChecked.filter(
								item => item.id !== value.id
							);
						}

						$scope.newProcessChecked.push(value);
					} else {
						$scope.newProcessChecked = $scope.newProcessChecked.filter(
							elem => value.id !== elem.id
						);
						$scope.newProcessChecked = [];
					}

					const hasTrue = $scope.processesList.some(item => item.__checked__);
					const hasFalse = $scope.processesList.some(item => !item.__checked__);

					if (hasTrue) {
						if (hasFalse) {
							$('#div-check-all').prop('indeterminate', true);
							$scope.allSelected = false;
						} else {
							$('#div-check-all').prop('indeterminate', false);
							$('#div-check-all').prop('checked', true);
							$scope.processesList.forEach(item => (item.__checked__ = true));
						}
					}
				});
			}, 0);
		};

		$scope.goBack = () => {
			$state.go(
				'root.default.addAutomaticProcesses',
				{},
				{
					inherit: false,
					reload: true
				}
			);
		};

		$scope.filterSituation = idSituation => {
			const id = idSituation;

			const situation = $scope.situations.find(c => c.id == id);

			if (situation) {
				$scope.filter.idSituation = idSituation;
				$scope.filter.situation = situation.nome;
			} else {
				$scope.filter.idSituation = '';
				$scope.filter.situation = '';
			}
		};

		$scope.filterCourt = idCourt => {
			const id = Number(idCourt);

			const court = $scope.courts.find(c => c.id === id);

			if (court) {
				$scope.filter.idCourt = idCourt;
				$scope.filter.court = court.nome;
			} else {
				$scope.filter.idCourt = '';
				$scope.filter.court = '';
			}
		};

		$scope.updateFilters = () => {
			$scope.lastFilter = { ...$scope.filter };

			$scope.fetchProcesses(1);
			$scope.newProcessChecked = [];

			const el = document.getElementById('movement-checkbox-all');

			if (el) {
				$scope.selectAllProcessesChecked = false;

				el.checked = false;
				el.indeterminate = false;
			}

			$scope.$applyAsync();
		};

		$scope.clearFilter = (filter, list) => {
			list.map(item => {
				filter[item] = '';
			});

			if (list[0] == 'situation' || list[0] == 'idSituation') {
				$scope.filterSituation(filter.idSituation);

				setTimeout(() => {
					$('#btnSituationFilter').triggerHandler('change');
				});
			}
			if (list[0] == 'court' || list[0] == 'idCourt') {
				$scope.filterCourt(filter.idCourt);

				setTimeout(() => {
					$('#btnCourtsFilter').triggerHandler('change');
				});
			}
		};

		$scope.toggleSelectAllProcesses = () => {
			const items = $scope.processesList || [];

			const noOneChecked =
				$scope.validItems > 0 && items.every(it => !it.__checked__);

			const nextValue = !!noOneChecked;

			items.forEach(it => {
				if (
					it.idSitProcPesqOABUsCliente == '-1' ||
					it.idSitProcPesqOABUsCliente == '-4'
				) {
					it.__checked__ = nextValue;
				} else {
					it.__checked__ = false;

					return false;
				}

				if (!$scope.newProcessChecked) {
					$scope.newProcessChecked = [];
				}

				const index = $scope.newProcessChecked.findIndex(
					process =>
						process.idProcPesqOABUsCliente === it.idProcPesqOABUsCliente
				);

				if (it.__checked__) {
					if (index === -1) {
						$scope.newProcessChecked.push(it);
					}
				} else {
					if (index !== -1) {
						$scope.newProcessChecked.splice(index, 1);
					}
				}

				return true;
			});

			$scope.updateMasterState();
		};

		$scope.toggleProcessItem = (item, forceChange = false) => {
			if (!item || $scope.allProcessesSelected) return;

			if (
				item.idSitProcPesqOABUsCliente != '-1' &&
				item.idSitProcPesqOABUsCliente != '-4'
			) {
				return;
			}

			if (forceChange) {
				item.__checked__ = !item.__checked__;
			}

			if (!$scope.newProcessChecked) {
				$scope.newProcessChecked = [];
			}

			const index = $scope.newProcessChecked.findIndex(
				process =>
					process.idProcPesqOABUsCliente === item.idProcPesqOABUsCliente
			);

			if (item.__checked__) {
				if (index === -1) {
					$scope.newProcessChecked.push(item);
				}
			} else {
				if (index !== -1) {
					$scope.newProcessChecked.splice(index, 1);
				}
			}

			$scope.updateMasterState();
		};

		$scope.toggleAllProcesses = () => {
			$scope.allProcessesSelected = !$scope.allProcessesSelected;

			if (!$scope.allProcessesSelected) {
				$scope.toggleSelectAllProcesses();

				$scope.newProcessChecked = [];
			}
		};

		$scope.getDisplayingRecordsValue = () => {
			return $scope.paginacao
				? $scope.paginacao.registrosTotal -
						$scope.paginacao.registrosPorPagina *
							($scope.paginacao.paginaAtual - 1) <
				  $scope.paginacao.registrosPorPagina
					? $scope.paginacao.registrosTotal -
					  $scope.paginacao.registrosPorPagina *
							($scope.paginacao.paginaAtual - 1)
					: $scope.paginacao.registrosPorPagina
				: 0;
		};

		$scope.updateQuantityPerPage = quantityPerPage => {
			const userParamsSession = sessionStorage.getItem('parametros-usuarios');

			let dataParameterUsers = null;

			if (
				userParamsSession &&
				userParamsSession != undefined &&
				userParamsSession != 'undefined'
			) {
				dataParameterUsers = JSON.parse(userParamsSession);
			}
			let record = dataParameterUsers;

			let paramUsuarioProdAdv = 0;

			if (record && record.idParamUsuarioProdAdv) {
				paramUsuarioProdAdv = record.idParamUsuarioProdAdv;
			}

			$scope.idQtdItensPagina = $scope.idQtdItensPagina
				? $scope.idQtdItensPagina
				: paramUsuarioProdAdv;

			let method = $scope.idQtdItensPagina ? 'PUT' : 'POST';

			$scope.quantityPerPage = quantityPerPage;

			$http({
				...helper.http(API.parametersUsers, method),
				data: {
					itens: [
						{
							id: record.idParamUsuarioProdAdv,
							qtdRegistroMovPorPagina: quantityPerPage || 20
						}
					]
				},
				messageOverride: {
					success() {},
					error() {}
				}
			}).then(() => {
				record.qtdRegistroMovPorPagina = quantityPerPage || 20;

				sessionStorage.setItem('parametros-usuarios', JSON.stringify(record));

				$scope.fetchProcesses();
			});
		};

		$scope.hasMovementsPrevPage = () => {
			return $scope.paginacao.paginaAtual > 1 ? true : false;
		};

		$scope.hasMovementsNextPage = () => {
			return $scope.paginacao.paginaAtual < $scope.paginacao.paginaTotal
				? true
				: false;
		};

		$scope.changePage = direction => {
			let newPage = 1;

			switch (direction) {
				case 'first':
					newPage = 1;
					break;
				case 'prev':
					newPage = $scope.paginacao.paginaAtual - 1;
					break;
				case 'next':
					newPage = $scope.paginacao.paginaAtual + 1;
					break;
				case 'last':
					newPage = $scope.paginacao.paginaTotal;
					break;
			}

			$scope.fetchProcesses(newPage);
		};

		$scope.importOab = () => {
			$scope.registerOabLoading = false;
			$scope.$applyAsync();

			$('#modalImportOab').modal('show');
		};

		$scope.confirmImportOab = () => {
			$scope.registerOabLoading = true;

			let data = {};

			if ($scope.allProcessesSelected) {
				data.idPesqProcOABXParamUsCliente = $scope.paramProcessId;
			} else {
				data.idsProcPesqOABUsCliente = [];

				$scope.newProcessChecked.map(process => {
					data.idsProcPesqOABUsCliente.push(process.idProcPesqOABUsCliente);
				});
			}

			$http({
				...helper.http(API.quickRegister, 'putImportProcess'),
				method: 'PUT',
				data: data,
				messageOverride: {
					success(response, notify) {
						notify.success('Processos importados com sucesso!');
					}
				}
			})
				.then(() => {
					$('#modalImportOab').modal('hide');
					$('#modalImportSuccess').modal('show');

					$scope.allProcessesSelected = false;

					$scope.updateFilters();
				})
				.catch(() => {
					$('#modalImportOab').modal('hide');
					$('#modalImportTryAgain').modal('show');
				})
				.finally(() => {
					$scope.registerOabLoading = false;
					$scope.$applyAsync();
				});
		};

		$scope.applyOnlyNumbers = () => {
			if (!$scope.filter.process) {
				return;
			}
			$scope.filter.process = $scope.filter.process
				.toString()
				.replace(/\D/g, '');
		};

		$scope.clearProcessFilter = () => {
			$scope.filter.process = '';
			$scope.filter.idProcess = null;
			$scope.processSelected = [];

			$timeout(() => {
				$('#btnFilterByProcess')
					.val(null)
					.trigger('change.select2');

				$('#btnFilterByProcessSelected')
					.val(null)
					.trigger('change.select2');
			}, 100);
		};

		$scope.changeProcessFilter = filters => {
			const $select = $('#btnFilterByProcess').length
				? $('#btnFilterByProcess')
				: $('#btnFilterByProcessSelected');

			const processText =
				filters.process || $select.attr('ng-custom-model') || null;

			const processId = $select.attr('ng-process-value') || null;

			filters.process = processText;
			filters.idProcess = processId;

			if (processText) {
				$scope.processSelected = [
					{
						numeroProcesso: processText,
						idProcPesqOABUsCliente: processId
					}
				];
			} else {
				$scope.processSelected = [];
			}
		};

		$scope.clearCourtsFilter = () => {
			$scope.filter.court = '';
			$scope.filter.idCourt = null;
			$scope.courtsSelected = [];

			$timeout(() => {
				$('#btnFilterByCourts')
					.val(null)
					.trigger('change.select2');

				$('#btnFilterByCourtsSelected')
					.val(null)
					.trigger('change.select2');
			}, 0);
		};

		$scope.changeCourtsFilter = filters => {
			const $select = $('#btnFilterByCourts').length
				? $('#btnFilterByCourts')
				: $('#btnFilterByCourtsSelected');

			const courtSigla =
				filters.court || $select.attr('ng-custom-model') || null;
			const courtId = $select.attr('ng-process-value') || null;

			filters.court = courtSigla;
			filters.idCourt = courtId;

			if (courtSigla) {
				$scope.courtsSelected = [
					{
						sigla: courtSigla,
						id: courtId
					}
				];
			} else {
				$scope.courtsSelected = [];
			}
		};

		$scope.changeCourtsFilter = filters => {
			const $select = $('#btnFilterByCourts').length
				? $('#btnFilterByCourts')
				: $('#btnFilterByCourtsSelected');

			const courtSigla =
				$select.attr('ng-custom-model') || filters.court || null;

			const courtId =
				$select.attr('ng-process-value') || filters.idCourt || null;

			if (!courtSigla) {
				return;
			}

			filters.court = courtSigla;
			filters.idCourt = courtId;

			$scope.courtsSelected = [
				{
					sigla: courtSigla,
					id: courtId
				}
			];
		};

		$scope.customSearch = text => text.replace(/[.,\/\-_]/g, '');

		$scope.goToFolder = idPastaUsuarioCliente => {
			var url = $state.href('root.default.movements.list4', {
				pasta: idPastaUsuarioCliente
			});

			window.open(url, '_blank');
		};

		$scope.isMobile =
			window && window.innerWidth && window.innerWidth <= 991 ? true : false;
		$scope.showTooltipLeftBottom =
			window && window.innerWidth && window.innerWidth <= 1400 ? true : false;
		$scope.popupSize = window.innerWidth <= 520 ? window.innerWidth - 20 : 500;
		$scope.registerOabTopbarInfoWidth = window.innerWidth - 160;

		$(window).resize(() => {
			let previousIsMobile = $scope.isMobile;
			let previousShowTooltipLeftBottom = $scope.showTooltipLeftBottom;
			let previousPopupSize = $scope.popupSize;
			let previousRegisterOabTopbarInfoWidth =
				$scope.registerOabTopbarInfoWidth;

			$scope.isMobile = window.innerWidth <= 991;
			$scope.showTooltipLeftBottom = window.innerWidth <= 1400;
			$scope.popupSize =
				window.innerWidth <= 520 ? window.innerWidth - 20 : 500;
			$scope.registerOabTopbarInfoWidth = window.innerWidth - 160;

			if (
				previousPopupSize !== $scope.popupSize ||
				previousRegisterOabTopbarInfoWidth !== $scope.registerOabTopbarInfoWidth
			) {
				$scope.$applyAsync();
			}
			if (
				$scope.isMobile != previousIsMobile ||
				$scope.showTooltipLeftBottom != previousShowTooltipLeftBottom
			) {
				$scope.$apply();
			}
		});

		$scope.onInit();
	}
]);

export default controller;
